import { useNavigate } from "react-router-dom";

const { ArrowRight } = {
  ArrowRight: () => <div>→</div>,
};

export const ContactSection = () => {
  const navigate = useNavigate();
  
  return (
    <section id="contact" className="py-20 bg-teal-600">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-light text-white mb-6 tracking-wide">
          LET'S CREATE SOMETHING{" "}
          <span className="italic text-white">beautiful</span>
        </h2>
        <div className="w-16 h-px bg-teal-400 mx-auto mb-8"></div>
        <p className="text-gray-100 mb-12 max-w-2xl mx-auto font-light leading-relaxed">
          Ready to capture your special moments? I'd love to hear about your
          vision and discuss how we can bring it to life through photography.
        </p>

        <div className="grid md:grid-cols-3 gap-8 mb-12 text-center">
          <div>
            <h3 className="font-light text-white mb-2 tracking-wide text-sm">
              EMAIL
            </h3>
            <p className="text-gray-100 font-light">info@shaszstudios.nl</p>
          </div>
          <div>
            <h3 className="font-light text-white mb-2 tracking-wide text-sm">
              PHONE
            </h3>
            <p className="text-gray-100 font-light">+31 645 725 494</p>
          </div>
          <div>
            <h3 className="font-light text-white mb-2 tracking-wide text-sm">
              LOCATION
            </h3>
            <p className="text-gray-100 font-light">Available across the Netherlands</p>
          </div>
        </div>

        <button 
          onClick={() => navigate("/book-now")} 
          className="group flex items-center gap-3 mx-auto bg-white text-teal-600 hover:bg-gray-100 px-12 py-4 font-light tracking-wide transition-all duration-300 text-sm"
        >
          GET IN TOUCH
          <ArrowRight className="group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </section>
  );
};

export default ContactSection;
